<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      activeCard: "credit",
      ReparisPlSel: ["Services", "Computer Repairs", "Plumbing"],
      JaSmiSel: ["Name", "Jacob Kline", "William Smith"],
    };
  },
  methods: {
    setActiveCard(cardType) {
      this.activeCard = cardType;
    },
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Plan & Billings</h5>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" class="btn btn-dark d-flex align-items-center"
                >Plans</a
              >
            </div>
          </div>
        </div>

        <!-- Plan & Billings -->
        <div class="row">
          <div class="col-lg-6 d-flex flex-column">
            <!-- Current Plan -->
            <h6 class="subhead-title">Current Plan</h6>
            <div class="card flex-fill">
              <div class="card-body">
                <div class="plan-info row">
                  <div class="col-md-9">
                    <div class="plan-term">
                      <h6 class="mb-1">Business</h6>
                      <p class="mb-2">Our most popular plan for small teams.</p>
                      <p class="fs-12 text-dark">
                        <i class="feather-calendar fs-12"></i> Renew Date:
                        <span class="fs-12 text-gray">Jan 22, 2023</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="plan-price">
                      <h4>$200</h4>
                      <p>per user/month</p>
                    </div>
                  </div>
                </div>
                <div class="plan-btns">
                  <a href="javascript:void(0);" class="btn btn-light me-2"
                    >Cancel Subscription</a
                  >
                  <a href="javascript:void(0);" class="btn btn-dark">Upgrade</a>
                </div>
              </div>
            </div>
            <!-- /Current Plan -->
          </div>
          <div class="col-lg-6 d-flex flex-column">
            <!-- Current Plan -->
            <h6 class="subhead-title">Payment</h6>
            <div class="card flex-fill">
              <div class="card-body">
                <div class="plan-info row">
                  <div class="col-md-9">
                    <div class="plan-term">
                      <h6 class="mb-1">Last Payment</h6>
                      <p class="fs-12 text-dark">
                        <i class="feather-calendar fs-12 me-1"></i
                        ><span class="fs-12 text-gray">January 22, 2022</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="plan-price d-flex justify-content-end">
                      <span
                        class="badge badge-soft-success d-inline-flex align-items-center"
                        >Active</span
                      >
                    </div>
                  </div>
                </div>
                <div class="plan-btns row">
                  <div class="col-md-7">
                    <div class="plan-term">
                      <h6 class="mb-1">Next Payment</h6>
                      <p class="fs-12 text-dark">
                        <i class="feather-calendar fs-12 me-1"></i
                        ><span class="fs-12 text-gray">January 22, 2023</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="d-flex justify-content-end">
                      <a href="javascript:void(0);" class="btn btn-dark"
                        >Manage Payment</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Current Plan -->
          </div>
          <div class="col-md-12">
            <h6 class="user-title">Payment Method</h6>
            <div class="row">
              <!-- Credit Card -->
              <div class="col-md-6 col-xl-4 d-flex flex-column">
                <div
                  class="card card-payments flex-fill"
                  :class="{ active: activeCard === 'credit' }"
                  @click="setActiveCard('credit')"
                >
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <h6>Credit Card</h6>
                        <div class="card-num">
                          <div class="visa-img">
                            <img src="@/assets/img/icons/visa.svg" alt="image" />
                          </div>
                          <h6>**** **** **** <span>9525</span></h6>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="card-remove d-flex justify-content-end">
                          <a href="javascript:void(0);" class="btn btn-sm btn-light"
                            >Remove Card <i class="feather-trash-2"></i
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Credit Card -->

              <!-- Debit Card -->
              <div class="col-md-6 col-xl-4 d-flex flex-column">
                <div
                  class="card card-payments flex-fill"
                  :class="{ active: activeCard === 'debit' }"
                  @click="setActiveCard('debit')"
                >
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <h6>Debit Card</h6>
                        <div class="card-num">
                          <div class="visa-img">
                            <img src="@/assets/img/icons/mastercard.svg" alt="image" />
                          </div>
                          <h6>**** **** **** <span>6842</span></h6>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="card-remove d-flex justify-content-end">
                          <a href="javascript:void(0);" class="btn btn-sm btn-light"
                            >Remove Card <i class="feather-trash-2"></i
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Debit Card -->

              <!-- Add Card -->
              <div class="col-md-6 col-xl-4 d-flex flex-column">
                <div class="card-payment-add flex-fill">
                  <a
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#add-payment"
                  >
                    <span class="rounded-circle"><i class="feather-plus"></i></span>
                  </a>
                </div>
              </div>
              <!-- /Add Card -->
            </div>

            <!-- Billing History -->
            <div class="page-header">
              <div class="row flex-fill">
                <div
                  class="d-flex justify-content-between align-items-center flex-wrap mb-4"
                >
                  <h5>Billing History</h5>
                  <div class="d-flex align-items-center">
                    <span class="text-dark me-2">Sort</span>
                    <div class="dropdown me-2">
                      <a
                        href="javascript:void(0);"
                        class="dropdown-toggle bg-light-300"
                        data-bs-toggle="dropdown"
                      >
                        Newly Added
                      </a>
                      <div class="dropdown-menu">
                        <a href="javascript:void(0);" class="dropdown-item active"
                          >Recently Added</a
                        >
                      </div>
                    </div>
                    <div class="dropdown me-2">
                      <a
                        href="javascript:void(0);"
                        class="dropdown-toggle bg-light-300"
                        data-bs-toggle="dropdown"
                      >
                        Export
                      </a>
                      <div class="dropdown-menu">
                        <a href="javascript:void(0);" class="dropdown-item active">Pdf</a>
                        <a href="javascript:void(0);" class="dropdown-item active"
                          >Excel</a
                        >
                      </div>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="tags d-flex justify-content-center align-items-center rounded me-2"
                      ><i class="ti ti-printer"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      class="tags d-flex justify-content-center align-items-center border rounded me-2"
                      id="filter_search"
                      @click="toggleFilterInputs"
                      ><i class="ti ti-adjustments"></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="filter_inputs"
              v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
            >
              <div class="row">
                <div class="col-lg-4 col-md-6">
                  <div class="mb-3">
                    <div class="sel-cal Calendar-icon">
                      <span><i class="ti ti-calendar-month"></i></span>
                      <date-picker
                        v-model="startdate"
                        placeholder=""
                        class="datetimepicker form-control"
                        :editable="true"
                        :clearable="false"
                        :input-format="dateFormat"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div class="mb-3">
                    <vue-select
                      :options="ReparisPlSel"
                      id="repairsplsel"
                      placeholder="Services"
                    />
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div class="mb-3">
                    <vue-select :options="JaSmiSel" id="jasimsel" placeholder="Name" />
                  </div>
                </div>
              </div>
            </div>
            <div class="provide-table">
              <div class="table-responsive">
                <table class="table datatable mb-0" id="data-table">
                  <thead class="thead-light">
                    <tr>
                      <th>Payout Date</th>
                      <th>Plan Name</th>
                      <th>Amount</th>
                      <th>Invoice</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-gray">28 Sep 2024</td>
                      <td class="text-body">Basic, Monthly</td>
                      <td class="text-gray fw-500">$50.00</td>
                      <td class="text-gray">Invoice 08 sep, 2023</td>
                      <td><span class="badge badge-soft-success">Paid</span></td>
                      <td class="d-flex">
                        <a href="javascript:void(0);"
                          ><span
                            class="p-1 bg-light-300 rounded-circle d-flex align-items-center justify-content-center"
                            ><i class="ti ti-eye"></i></span
                        ></a>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-gray">28 Oct 2024</td>
                      <td class="text-body">Standard, Monthly</td>
                      <td class="text-gray fw-500">$200.00</td>
                      <td class="text-gray">Invoice 08 Oct, 2022</td>
                      <td><span class="badge badge-soft-success">Paid</span></td>
                      <td class="d-flex">
                        <a href="javascript:void(0);"
                          ><span
                            class="p-1 bg-light-300 rounded-circle d-flex align-items-center justify-content-center"
                            ><i class="ti ti-eye"></i></span
                        ></a>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-gray">28 Nov 2024</td>
                      <td class="text-body">Enterprice, Year</td>
                      <td class="text-gray fw-500">$200.00</td>
                      <td class="text-gray">Invoice 08 Nov, 2022</td>
                      <td><span class="badge badge-soft-success">Paid</span></td>
                      <td class="d-flex">
                        <a href="javascript:void(0);"
                          ><span
                            class="p-1 bg-light-300 rounded-circle d-flex align-items-center justify-content-center"
                            ><i class="ti ti-eye"></i></span
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <div id="tablelength"></div>
              </div>
              <div class="col-md-7">
                <div class="table-ingopage">
                  <div id="tableinfo"></div>
                  <div id="tablepagination"></div>
                </div>
              </div>
            </div>
            <!-- /Billing History -->
          </div>
        </div>
        <!-- /Plan & Billings -->
      </div>
    </div>
    <!-- /Page Wrapper -->
    <provider-plan-modal></provider-plan-modal>
  </div>
</template>
